<div class="container" (click)="select()">
  <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="16px">

    <div style="overflow-wrap: anywhere;" fxFlex>
      {{data.message}}
    </div>

    <div *ngIf="!isMobileMode" fxFlex="nogrow">
      <mat-divider [vertical]="true" [inset]="false" style="height: 100px"></mat-divider>
    </div>

    <div *ngIf="!isMobileMode" fxFlex="nogrow">
      <div>
        <button (click)="close()" mat-icon-button>
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

  </div>

</div>
<mat-progress-bar color="accent" mode="determinate" [value]="interval$ | async"></mat-progress-bar>
